var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0072 17.0687C10.8754 17.0694 10.7448 17.0442 10.6228 16.9946C10.5008 16.9449 10.3898 16.8717 10.2962 16.7791C10.2024 16.6863 10.1279 16.5759 10.077 16.4542C10.0262 16.3326 10 16.2021 10 16.0703C10 15.9384 10.0262 15.8079 10.077 15.6863C10.1279 15.5646 10.2024 15.4542 10.2962 15.3614L13.6108 11.9991L10.2912 8.6367C10.1047 8.44963 10 8.19658 10 7.93281C10 7.66904 10.1047 7.41599 10.2912 7.22892C10.3843 7.13534 10.495 7.06107 10.6171 7.01038C10.7391 6.95969 10.87 6.93359 11.0022 6.93359C11.1344 6.93359 11.2653 6.95969 11.3873 7.01038C11.5093 7.06107 11.6201 7.13534 11.7132 7.22892L15.7137 11.3002C15.8972 11.4868 16 11.7377 16 11.9991C16 12.2604 15.8972 12.5113 15.7137 12.698L11.7082 16.7492C11.6183 16.846 11.5101 16.924 11.3898 16.9789C11.2694 17.0337 11.1394 17.0642 11.0072 17.0687Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/ArrowRightWhite.659a548ce0e2a13043c198a4b3d31718.svg";
export { ForwardRef as ReactComponent };